import { setNotification } from "features/Notification/notificationSlice";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function MOProductWages({ formData, setFormData, isViewOnly }) {
  const dispatch = useDispatch();
  /*   All States
   ********************************************* */

  const [loading, setLoading] = useState(false);
  const [rateTypes, setRateTypes] = useState([]);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };
  const handleWageChange = (e) => {
    setFormData({ ...formData, productWageId: e.target.value });
  };

  const fetchWagesRateTypes = async (styleId) => {
    if (!styleId) return;
    try {
      loadingOn();
      const { data } = await API.post(
        "/rate-types",
        { styleId: styleId },
        { headers: authHeader() }
      );
      if (data?.success) {
        setRateTypes(data?.data);
        if (
          data?.data?.length > 0 &&
          (formData?.productWageId === "" ||
            formData?.productWageId === null ||
            formData?.productWageId === undefined)
        ) {
          setFormData({
            ...formData,
            productWageId: data?.data[0]?.rateTypeId,
          });
        }
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (formData?.productStyle) {
        fetchWagesRateTypes(formData?.productStyle);
      }
    }, 1500);
    return () => clearTimeout(timeout);
  }, [formData?.productStyle]);

  return (
    <div className="d-flex align-items-center gap-1">
      <select
        name="productWageId"
        id="productWageId"
        onChange={handleWageChange}
        value={formData?.productWageId}
        disabled={isViewOnly}
        className="form-control"
      >
        <option value="0">No Payment</option>
        {rateTypes?.map((rate) => (
          <option key={rate?.rateTypeId} value={rate?.rateTypeId}>
            {rate?.name}
          </option>
        ))}
      </select>

      {/* Button to re fetch  */}
      <button
        type="button"
        className="btn btn-outline-primary "
        onClick={() => fetchWagesRateTypes(formData?.productStyle)}
        disabled={loading || isViewOnly || !formData?.productStyle}
      >
        <span className="d-flex align-items-center justify-content-center">
          <i className={`mdi mdi-refresh ${loading ? "animate-spin" : ""}`}></i>
        </span>
      </button>
    </div>
  );
}
